import { Pipe, PipeTransform } from '@angular/core';
import { SCHOOL } from 'src/app/core/dummy/config';
import { fileSize } from '../services/mapping.service';

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {


  transform(value: any, args?: any): any {
    if (value) return fileSize(value)
    return null;
  }


}



@Pipe({ name: 'replaceStorageId' })
export class replaceStorageIdPipe implements PipeTransform {
  transform(url: any): any {
    if (!url || typeof url !== 'string') {
      return url;
    }

    if (SCHOOL.key === 'ngs' && SCHOOL.psis !== 'gdi_training') {
      const str = 'ngsclouddev.appspot.com';
      const replaceUrl = url.replace(/\/b\/.*\/o\//, `/b/${str}/o/`);
      return replaceUrl;
    } else if (SCHOOL.key === 'ngs-preakleap') {
      const str = 'ngs-preakleap-new.firebasestorage.app';
      const replaceUrl = url.replace(/\/b\/.*\/o\//, `/b/${str}/o/`);
      return replaceUrl;
    } else {
      return url;
    }
  }
}

